import React from 'react';
import {
  Button,
  Card, CardBody, CardTitle, Col, Row,
} from 'reactstrap';
import { get } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import BaseGrid from '../../components/Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function ScrapRecordsPage() {
  const csvFrom = async (row) => {
    const from = row.created_at;
    const rowsForward = await get(`${url.GET_SCRAP_RECORDS_SINCE}?startDate=${from}`);
    const columnTitles = ['id', 'created_at', 'lot',
      'sku', 'stock_id', 'inventory_id', 'qty', 'user'];
    const csvRows = rowsForward.map((r) => columnTitles.map((col) => r[col]).join(','));
    const csv = `${columnTitles.join(',')}\n${csvRows.join('\n')}`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = csvUrl;
    a.download = `scrap_records_${from.slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const csvForMonth = async (month) => {
    // get month from today
    const from = new Date();
    from.setMonth(from.getMonth());
    from.setDate(1);
    from.setHours(0, 0, 0, 0);
    const fromIso = from.toISOString().slice(0, 10);
    const rows = await get(`${url.GET_SCRAP_RECORDS_SINCE}?startDate=${fromIso}`);
    const columnTitles = ['id', 'created_at', 'lot',
      'sku', 'stock_id', 'inventory_id', 'qty', 'user'];
    const csvRows = rows.map((r) => columnTitles.map((col) => r[col]).join(','));
    const csv = `${columnTitles.join(',')}\n${csvRows.join('\n')}`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const csvUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = csvUrl;
    a.download = `scrap_records_${month}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <CardTitle className="h4">Scrap Records</CardTitle>
                <Button
                  color="primary"
                  className="mb-2 me-2"
                  onClick={() => csvForMonth(new Date().toISOString().slice(0, 7))}
                >
                  Export This Month
                </Button>
                <Can i="see" this="Log">
                  <BaseGrid
                    url={url.GET_SCRAP_RECORDS}
                    config={
                      {
                        columns: {
                          id: { label: 'ID', sort: true },
                          created_at: {
                            label: 'Date',
                            sort: true,
                            date: {
                              timezone: process.env.REACT_APP_LOCAL_TZ,
                              format: (d) => d.toLocaleString(),
                            },
                          },
                          lot: { label: 'Lot', sort: true },
                          sku: {
                            label: 'SKU',
                            sort: true,
                            link: {
                              to: '/inventory/%inventory_id%',
                            },
                          },
                          stock_id: {
                            label: 'Stock ID',
                            sort: true,
                            link: {
                              to: '/inventory/%inventory_id%',
                            },
                          },
                          qty: { label: 'Quantity', sort: true },
                          user: { label: 'User', sort: true },
                          actions: {
                            label: 'Export CSV',
                            actions: [
                              {
                                key: 'csv_from',
                                icon: 'mdi mdi-disc',
                                class: 'btn btn-sm btn-soft-warning text-dark',
                                alt: 'Start here',
                                click: csvFrom,
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'created_at',
                          direction: 'desc',
                          perPage: 50,
                        },
                      }
                    }
                  />
                </Can>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ScrapRecordsPage;
